import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import useEnhancedNavigate from "./Session/helpers";
import { PurchaseCard } from "../redux/slices/finchatSlice";

type UnlockCardProps = {
  bundleName: string;
  price?: PurchaseCard["price"];
  variant?: "inline" | "compact";
  onClick?: () => void;
};

const formatPrice = (price?: UnlockCardProps["price"]) => {
  if (!price || price.amount === null || price.amount === undefined) {
    return null;
  }
  const interval = /^(year|annual)/.test(price.interval) ? "yr" : "mo";
  return `$${price.amount}/${interval}`;
};

// Unlock CTAs route in-app to /plans; purchase_url is deliberately ignored.
const UnlockCard = ({ bundleName, price, variant = "inline", onClick }: UnlockCardProps) => {
  const navigate = useEnhancedNavigate();
  const priceLabel = formatPrice(price);
  const pillClasses = "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-tgpt-secondary-states-outlinedBorder text-tgpt-secondary-main hover:bg-tgpt-secondary-states-hover transition-colors text-sm";

  const handleClick = () => {
    onClick?.();
    navigate("/plans");
  };

  return (
    <button type="button" onClick={handleClick} className={pillClasses}>
      <LockOutlinedIcon className="!w-3.5 !h-3.5" />
      <span>
        {variant === "compact" ? "Unlock " : "Unlock access to "}
        <span className="font-semibold">{bundleName}</span>
      </span>
      {priceLabel && <span className="opacity-60">{priceLabel}</span>}
    </button>
  );
};

export default UnlockCard;
